export const SESSION_COOKIE_NAME = 'session';
export const TOKEN_COOKIE_NAME = 'token';
export const TOKEN_BINDING_COOKIE_NAME = 'token_binding';

/** Host-only access token cookie written by the shared auth client (`packages/auth-client`). */
export const WAND_TOKEN_COOKIE_NAME = 'wand_token';
